import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { unloadChance, viewChance } from '../../modules/chanceModule/chance';
import { Outlet } from 'react-router-dom';
import ChanceTemplate from '../../components/chancemng/ChanceTemplate';
import ChanceInfoContainer from './info/ChanceInfoContainer';

const ChanceContainer = () => {
  const { id } = useParams();
  let navigate = useNavigate();
  //처음 마운트 될 때 partenr 데이터 요청
  const dispatch = useDispatch();
  const { chance, error, loading } = useSelector(
    ({ chanceModule, loading }) => ({
      chance: chanceModule.chance.chance,
      error: chanceModule.chance.error,
      loading: loading['chance/VIEW_CHANCE'],
    }),
  );

  useEffect(() => {
    dispatch(viewChance(id));

    //언마운트될때 리덕스에서 파트너 데이터 초기화
    return () => {
      dispatch(unloadChance());
    };
  }, [dispatch, id]);

  const handleGoBack = () => {
    navigate('/chancemng');
  };

  return (
    <>
      <ChanceTemplate chance={chance} loading={loading} error={error}>
        <ChanceInfoContainer handleGoBack={handleGoBack} />
      </ChanceTemplate>
      <Outlet />

    </>
  );
};

export default ChanceContainer;
